import { render } from "./qs-sxpr-sw-view.vue?vue&type=template&id=9095fa00&scoped=true"
import script from "./qs-sxpr-sw-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qs-sxpr-sw-view.vue?vue&type=script&setup=true&lang=js"

import "./qs-sxpr-sw-view.vue?vue&type=style&index=0&id=9095fa00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9095fa00"],['__file',"src/views/tep/tep-nsi/qs-sxpr-sw-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9095fa00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9095fa00', __exports__)) {
    api.reload('9095fa00', __exports__)
  }
  
  module.hot.accept("./qs-sxpr-sw-view.vue?vue&type=template&id=9095fa00&scoped=true", () => {
    api.rerender('9095fa00', render)
  })

}


export default __exports__